<template>
  <div class="inline-block">
    <span @click="handleOpen">
      <slot></slot>
    </span>
    <el-dialog :title="title" :visible.sync="dialogVisible" :width="width" @close="close">
      <sirui-search
        v-if="searchColumns.length"
        ref="siruiSearch"
        :query="query"
        :columns="searchColumns"
        :colSpan="colSpan"
        :buttonSpan="buttonSpan"
        @resetBtnClick="resetBtnClick"
        @searchBtnClick="search"
        @changeChecked="changeChecked"
        @searchCompanyName="searchCompanyName"
        @changeMethod="changeMethod"
      ></sirui-search>
      <div class="main-content">
        <sirui-table
          :rowKey="propCode || 'id'"
          ref="siruiTable"
          :loading="load"
          :data="tableData"
          :paging="page"
          :checkRowKeys="curCheckedKeys"
          :checkboxConfig="checkboxConfig"
          @sortChangeEvent="sortChangeEvent"
          @handleSizeChange="handleSizeChange"
          @handleCurrentChange="handlePagination"
          @handleSelectionChange="handleSelectionChange"
          @dblclickEvent="dblclickEvent"
        >
          <vxe-table-column
            v-if="isMultiple"
            type="checkbox"
            width="50"
            fixed="left"
          ></vxe-table-column>
          <vxe-table-column v-else type="radio" width="50" fixed="left"></vxe-table-column>
          <vxe-table-column
            v-for="(item, index) in columnList"
            :key="index"
            :type="item.type"
            :fixed="item.fixed"
            :field="item.prop"
            :title="item.label"
            :width="item.width || columnWidth"
            :sortable="item.sortable"
            :formatter="item.formatter"
          >
            <template slot-scope="scope">
              <span v-if="typeof item.render == 'function'">
                {{ item.render(scope.row[item.prop], scope.row) }}
              </span>
              <span v-else-if="item.dictType">
                {{ scope.row[item.prop] | getDictNameByCode(item.dictType) }}
              </span>
              <span v-else-if="item.format">
                {{ scope.row[item.prop] | formatTableColumn(item.format) }}
              </span>
              <span v-else>{{ scope.row[item.prop] }}</span>
            </template>
          </vxe-table-column>
        </sirui-table>
      </div>
      <div slot="footer" ref="footer" class="dialog-footer">
        <el-button @click="close">{{ $t('dialog.cancel') }}</el-button>
        <el-button type="primary" @click="handleConfirm">{{ $t('dialog.confirm') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import SiruiSearch from '@/components/SiruiSearch';
  import SiruiTable from '@/components/SiruiTable';
  import { filterEmpty, toLine } from '@/common/js/util';
  import tradeApi from '@/api/receivablesAndPayables/trade.js';
  export default {
    props: {
      checkboxConfig: {
        type: Object,
        default: () => {},
      },
      title: {
        // 弹窗标题
        type: String,
        default: () => '',
      },
      width: {
        // 弹窗宽度
        type: String,
        default: () => '800px',
      },
      //搜索区域的内容
      searchColumns: {
        type: Array,
        default: () => [],
      },
      kpSelectId: {
        type: Array,
        default: () => [],
      },
      // 查询的接口
      API: {
        type: String,
        default: () => '',
      },
      page: {
        type: Boolean,
        default: () => true,
      },
      getDataKey: {
        type: String,
        default: () => 'list',
      },
      // 额外参数
      extraData: {
        type: Object,
        default: () => {},
      },
      // 表格展示的内容
      columnList: {
        type: Array,
        default: () => [],
      },
      // 是否多选
      isMultiple: {
        type: Boolean,
        default: () => true,
      },
      // 外部控制弹窗是否显示
      defaultVisible: {
        type: Boolean,
        default: () => false,
      },
      // 设置默认选中
      checkRowKeys: {
        type: Array,
        default: () => [],
      },
      // 表格列默认宽度
      columnWidth: {
        type: Number,
        default: undefined,
      },
      // 选中字段的key
      propCode: {
        type: String,
        default: 'id',
      },
      // 搜索默认分隔的colSpan，分成三列
      colSpan: {
        type: Number,
        default: 8,
      },
      // 右边按钮占位，弹窗占位需要宽一点
      buttonSpan: {
        type: Number,
        default: 4,
      },
      // 确认后是否选中，默认再次打开之前的还是选中的
      confirmUnchecked: {
        type: Boolean,
        default: true,
      },
      // 接口访问类型
      type: {
        type: String,
        default: 'post',
      },
      // 区分多个请求
      isManyApi: {
        type: Boolean,
        default: false,
      },
      // 是否开票进来
      isInvoice: {
        type: String,
        default: '',
      },
    },
    components: {
      SiruiSearch,
      SiruiTable,
    },
    data() {
      return {
        dialogVisible: false,
        load: false,
        tableData: [],
        query: {},
        multipleSelection: [],
        curCheckedKeys: this.checkRowKeys,
      };
    },
    watch: {
      defaultVisible() {
        if (this.defaultVisible) {
          this.handleOpen();
        }
        this.dialogVisible = this.defaultVisible;
      },
      checkRowKeys(newValue) {
        this.curCheckedKeys = newValue;
      },

      query: {
        handler(newValue) {
          this.$emit('changeQuery', newValue);
        },
        deep: true,
      },
      API: {
        handler(newValue) {
          console.log('请求路径', newValue);
        },
        deep: true,
      },
    },
    mounted() {
      this.initQuery();
    },
    methods: {
      handleOpen() {
        this.initQuery();
        this.dialogVisible = true;
        this.$nextTick(() => {
          this.getData();
          this.$emit('open');
        });
      },
      changeChecked() {
        this.getData();
      },
      searchCompanyName(val) {
        this.$emit('searchCompanyName', val);
      },
      changeMethod(val) {
        this.$emit('changeMethod', val);
      },
      // 初始化查询参数
      initQuery() {
        const query = {};
        this.searchColumns.forEach((item) => {
          if (item.prop) {
            if (typeof item.prop === 'string' && item.type != 'checkbox') {
              query[item.prop] = undefined;
            } else if (item.type == 'checkbox') {
              if (item.isChecked) {
                query[item.prop] = 1;
              } else {
                query[item.prop] = 0;
              }
            } else {
              item.prop.forEach((prop) => {
                query[prop] = undefined;
              });
            }
          }
        });
        this.query = Object.assign({}, query);
      },
      close() {
        this.dialogVisible = false;
        if (this.searchColumns[0]) this.$refs.siruiSearch.resetForm('queryFrom');
        this.$emit('close');
      },
      handleConfirm() {
        const curSelect = this.isMultiple
          ? this.$refs.siruiTable.getCheckboxRecords()
          : [this.$refs.siruiTable.getRadioRecord()];
        const prevSelectedList = this.$refs.siruiTable.getCheckboxReserveRecords(); // 历史选中数据
        const selectedList = curSelect.concat(prevSelectedList); // 选中数据
        // 点击后注入选中keys，再次打开保留选中，如果不需要则不操作
        if (this.confirmUnchecked) {
          this.curCheckedKeys = selectedList.map((item) => {
            return item[this.propCode];
          });
        }
        this.$emit('confirm', selectedList);
      },
      getData(search) {
        if (!this.API) return;
        const query = this.getQuery();
        if (search && Object.keys(query).length == 2) {
          this.$message({
            showClose: true,
            message: this.$t('search.nosearchError'),
            type: 'error',
          });
          return;
        }
        const params = Object.assign({}, this.extraData, query);
        this.load = true;
        // TODO settlementBusinessType=01
        console.log(
          params,
          '===>>',
          this.isManyApi,
          params.settlementBusinessType,
          tradeApi.RECEIVABLESLIST_QUERY
        );
        let url =
          this.isManyApi && params.settlementBusinessType != '01'
            ? tradeApi.RECEIVABLESLIST_QUERY
            : this.API;
        // 销售发票申请，多式联运取行信息
        if (this.isInvoice == 'invoice' && ['02', '06'].includes(params.settlementBusinessType)) {
          url = this.API;
        }
        console.log(url, '111111111====>>>>', this.API, this.kpSelectId);
        this.$axios[this.type](url, params)
          .then((res) => {
            this.load = false;
            if (0 == res.data.code) {
              if (this.page) {
                this.tableData = res.data.data[this.getDataKey];
                if (this.kpSelectId.length != 0) {
                  this.tableData = this.tableData.filter(
                    (item) => !this.kpSelectId.includes(item?.id?.toString())
                  );
                }
                this.$refs.siruiTable.reloadTable(this.tableData);
                this.$refs.siruiTable.setPageTotal(res.data.data.total);
              } else {
                this.tableData = res.data.data;
              }
            } else {
              this.$message({
                showClose: true,
                message: res.data.msg,
                type: 'error',
              });
            }
          })
          .catch(() => {
            this.load = false;
          });
      },
      // 获取查询参数
      getQuery() {
        // 分页数据
        const { pageNum, pageSize } = this.$refs.siruiTable.page;
        const query = this.query;
        const result = Object.assign({}, query, {
          pageNum,
          pageSize,
        });
        this.searchColumns.forEach((item) => {
          if (item.getSearchCode) {
            const arr = query[item.prop];
            if (arr && Array.isArray(arr) && arr.length) {
              const codes = arr.map((code) => {
                if (code) {
                  if (item.getSearchCode == 'partnerCode') {
                    return code.allPartnerCode ? code.allPartnerCode : code[item.getSearchCode];
                  } else if (item.getSearchCode == 'productDetailCode') {
                    return code.allProductDetailCode
                      ? code.allProductDetailCode
                      : code[item.getSearchCode];
                  } else {
                    return code[item.getSearchCode];
                  }
                }
              });
              // 单选改第一个，多选给多个
              result[item.prop] = item.isMultiple ? codes[0] : codes;
            }
          }
        });
        return filterEmpty(result);
      },
      // 表格排序
      sortChangeEvent({ property, order }) {
        let orderByDesc = '';
        if (order) {
          orderByDesc = `${toLine(property)} ${order}`;
        }
        const query = Object.assign({}, this.query, {
          orderByDesc,
        });
        this.query = query;
        this.getData();
      },
      // 点击分页
      handlePagination() {
        this.getData();
      },
      // 分页条数改变
      handleSizeChange() {
        this.getData();
      },
      // 搜索
      search() {
        this.$refs.siruiTable.setPageNum(1);
        this.getData(true);
      },
      //双击单元格事件
      dblclickEvent(val) {
        this.$emit('dblclickEvent', val);
      },
      // 表格选中行
      handleSelectionChange(row) {
        this.multipleSelection = row;
      },
      setSearchValue(key, value) {
        console.log(this.query);
        if (Object.prototype.hasOwnProperty.call(this.query, key)) {
          // this.query[key] = value;
          this.$set(this.query, key, value);
        }
      },
      // 重置
      resetBtnClick() {
        this.$emit('resetBtnClick');
        this.$refs.siruiTable.clearCheckboxReserve();
        this.$refs.siruiTable.setPageNum(1);
        this.$refs.siruiTable.setPageSize(10);
        this.getData();
      },
    },
  };
</script>
<style scoped lang="scss">
  .inline-block {
    display: inline-block;
  }
</style>
